module.exports = __webpack_public_path__ + "static/withfriends-automated-member-tiers-0f7fbc2485a52acf36f454e0b5d172ee.webm";